import React, { useState } from 'react';

import { Row, Col, Label, FormGroup } from 'twyne-new.ui';

import Input from 'components/formsy/Input';

import APICkecker from '../APICkecker';

export default function PermissionData({ name, data = {} }) {
  const [login, setLogin] = useState(data.login || '')
  const [password, setPassword] = useState(data.password || '')
  const [pub_code, setPubCode] = useState(data.pub_code || '')
  const [pub_key, setPubKey] = useState(data.pub_key || '')

  return <>
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Login</Label>
          <Input required
            name="login"
            value={login}
            onChange={setLogin}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Pin</Label>
          <Input type="password" required
            name="password"
            value={password}
            onChange={setPassword}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Pub Code</Label>
          <Input
            name="pub_code"
            value={pub_code}
            onChange={setPubCode}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Pub Key</Label>
          <Input
            name="pub_key"
            value={pub_key}
            onChange={setPubKey}
          />
        </FormGroup>
      </Col>
    </Row>
    <APICkecker
      partner={name}
      credentials={{ login, password, pub_code, pub_key }}
    />
  </>
}
